import { ReactElement } from 'react';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

type Props = {
  content?: ReactElement | string;
};

export const ComparisonText = ({ content }: Props) => {
  return (
    <div style={{ display: 'flex', gap: theme.spacing(1) }}>
      <Icon
        name='bulb-small'
        size={20}
        style={{
          color: theme.colors.tangerine40,
          marginTop: theme.spacing(0.25),
        }}
      />
      <Text>{content}</Text>
    </div>
  );
};
